import { FC } from "react";

interface Props {
  label?: string;
  labelHtml?: () => any;
  id?: string;
  name?: string;
  onChange?: (value: boolean) => void;
}

const Checkbox: FC<Props> = ({ label, labelHtml, id, name, onChange }) => {
  return (
    <div className="tw-mt-6 tw-flex tw-items-center">
      <input
        id={id}
        name={name}
        type="checkbox"
        className="tw-h-4 tw-w-4 tw-border-gray-300 tw-rounded tw-text-indigo-600 focus:tw-ring-indigo-500"
        onChange={(e) => {
          onChange && onChange(e.target.checked);
        }}
      />
      <div className="tw-ml-2">
        <label htmlFor={name} className="tw-text-sm tw-font-medium tw-text-gray-900">
          {labelHtml && labelHtml()}
        </label>
      </div>
    </div>
  );
};

export default Checkbox;
